import { Market } from "@models/Market";
import { Territory } from "@models/Territory";

export enum OrderingCtxType {
  Market = "market",
  Territory = "territory",
  AllRegions = "all-regions",
}

export const TERRITORY_GROUP = "TERRITORIES";

export type DistributorOrderingCtx = {
  id: string; // a unique identifier used for the selector
  name: string;
  group: string;
  isOrderable: boolean;
  type: OrderingCtxType;
  marketId?: string;
  territoryId?: string;
  market?: Market | null;
  territory?: Territory | null;

  /** If true, order-sets require a channel and pre-order order-sets require a program at the OS level. */
  usesLegacyOrdering?: boolean;
};

export const getOrderingCtxId = (type: OrderingCtxType, id: string) => {
  return `${type}-${id}`;
};

export const SWEEPSTAKE_ORDERING_CTX_ID = getOrderingCtxId(
  OrderingCtxType.AllRegions,
  "sweepstake"
);

export const ALL_REGIONS_ORDERING_CTX_ID = getOrderingCtxId(
  OrderingCtxType.AllRegions,
  "all-regions"
);
